class Callbacks {
  static handleOnAddressResolve(setFormValues, address) {
    return function addressResolve(details) {
      setFormValues([{ field: 'address_details', value: details }])
    }
  }
}

export default Callbacks
